import { useEffect } from 'react';

export default function useViewportHeight() {
  useEffect( () => {
    const updateHeight = () => {
      document.documentElement.style.setProperty( '--vh', `${window.innerHeight * 0.01}px` );
    };

    window.addEventListener( 'resize', updateHeight );

    updateHeight();

    return () => window.removeEventListener( 'resize', updateHeight );
  }, [] );
}
